import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import { Project, ProjectDetailTabKeys } from 'api/project';
import { BreadCrumbs } from 'components/molecules/project-details/header/breadcrumbs';
import { ProjectTitle } from 'components/molecules/project-details/header/project-title';
import { ProjectDetailTabs } from 'components/molecules/project-details/header/tabs/tabs';
import { StatusUpdatesPage } from 'components/organisms/status-updates';
import { ProjectDetailsPageTemplate } from 'components/templates/project-details';
import { useProjectWebsocket } from 'hooks/websockets';

export const ProjectStatusUpdatesPage: FC<{ project: Project }> = ({
  project,
}) => {
  useProjectWebsocket(ProjectId(project.projectId));

  return (
    <ProjectDetailsPageTemplate
      title={<ProjectTitle project={project} />}
      tabs={
        <ProjectDetailTabs
          projectId={ProjectId(project.projectId)}
          activeTabKey={ProjectDetailTabKeys.StatusUpdate}
        />
      }
      documentTitle={project.projectName}
      breadCrumbs={<BreadCrumbs />}
    >
      <StatusUpdatesPage />
    </ProjectDetailsPageTemplate>
  );
};
